module.exports = __webpack_public_path__ + "static/media/6m.88e558cf.png";